/* NutriKit Product Section JS
 * Sticky CTA mobile + Tabs + Gallery thumbs + Variant change handler
 */
(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.nkInitialized === 'true') return;
    section.dataset.nkInitialized = 'true';

    initTabs(section);
    initGalleryThumbs(section);
    initStickyCta(section);
    initVariantUpdates(section);
  }

  /* ===== VARIANT CHANGE HANDLER =====
     Met a jour prix, savings, doses, stock quand variant change.
     Lit les variants depuis le JSON dans <variant-radios>. */
  function initVariantUpdates(section) {
    var variantRadios = section.querySelector('variant-radios');
    if (!variantRadios) return;
    var jsonScript = variantRadios.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    // Optional per-variant specs map (custom.servings_count, serving_size, protein_per_serving)
    var variantSpecs = {};
    var specsScript = variantRadios.querySelector('script[data-nk-variant-specs]');
    if (specsScript) {
      try { variantSpecs = JSON.parse(specsScript.textContent); } catch (e) { variantSpecs = {}; }
    }

    var fallbackServingSize = parseInt(section.dataset.servingSize || '0', 10);
    var moneyFormat = section.dataset.moneyFormat || '€{{amount}}';

    function formatMoney(cents) {
      var amount = cents / 100;
      var withDecimal = amount.toFixed(2);
      var withComma = withDecimal.replace('.', ',');
      var thousandsComma = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var thousandsCommaSep = withComma.replace(/\B(?=(\d{3})+(?!\d))(?=.+,)/g, ' ');
      var noDecimals = Math.round(amount).toString();
      return moneyFormat
        .replace('{{amount}}', thousandsComma)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_with_comma_separator}}', withComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals)
        .replace('{{amount_with_space_separator}}', thousandsCommaSep)
        .replace('{{amount_no_decimals_with_space_separator}}', noDecimals)
        .replace('{{amount_with_apostrophe_separator}}', withComma)
        .replace('{{amount_with_period_and_space_separator}}', withDecimal);
    }

    function findSelectedVariant() {
      var inputs = variantRadios.querySelectorAll('input[type="radio"]:checked');
      var selected = [];
      inputs.forEach(function (i) { selected.push(i.value); });
      return variants.find(function (v) {
        for (var idx = 0; idx < selected.length; idx++) {
          var optKey = 'option' + (idx + 1);
          if (v[optKey] !== selected[idx]) return false;
        }
        return true;
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      var priceMain = section.querySelector('[data-price-main]');
      if (priceMain) priceMain.textContent = formatMoney(variant.price);

      var priceCompare = section.querySelector('[data-price-compare]');
      var priceDiscount = section.querySelector('[data-price-discount]');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (priceCompare) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.removeAttribute('hidden');
        }
        if (priceDiscount) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          priceDiscount.textContent = '-' + pct + '%';
          priceDiscount.removeAttribute('hidden');
        }
      } else {
        if (priceCompare) { priceCompare.textContent = ''; priceCompare.setAttribute('hidden', ''); }
        if (priceDiscount) { priceDiscount.textContent = ''; priceDiscount.setAttribute('hidden', ''); }
      }

      // Update specs : prefer per-variant metafields, fallback weight/serving_size calc
      var spec = variantSpecs[variant.id] || {};
      var doses = parseInt(spec.servings_count || 0, 10);
      var serveSize = parseInt(spec.serving_size || 0, 10) || fallbackServingSize;
      var protein = parseFloat(spec.protein_per_serving || 0);
      if (!doses && variant.weight && serveSize > 0) {
        doses = Math.floor(variant.weight / serveSize);
      }
      var servingsEl = section.querySelector('[data-spec-servings]');
      if (servingsEl && doses > 0) servingsEl.textContent = String(doses);
      var serveSizeEl = section.querySelector('[data-spec-serving-size]');
      if (serveSizeEl && serveSize > 0) serveSizeEl.textContent = String(serveSize);
      var proteinEl = section.querySelector('[data-spec-protein]');
      if (proteinEl && protein > 0) {
        // Format aligne sur Liquid : entier sans virgule, decimal avec virgule francaise
        var rounded = Math.round(protein * 10) / 10;
        var formatted = (rounded === Math.floor(rounded))
          ? String(Math.floor(rounded))
          : String(rounded).replace('.', ',');
        proteinEl.textContent = formatted;
      }

      var stockEl = section.querySelector('[data-stock-indicator]');
      if (stockEl && variant.inventory_management === 'shopify') {
        var qty = variant.inventory_quantity || 0;
        var dotClass, label;
        if (qty > 10) { dotClass = 'stock-dot--ok'; label = 'En stock, expédié sous 24h'; }
        else if (qty > 0) { dotClass = 'stock-dot--low'; label = 'Stock limité (' + qty + ' disponibles), expédié sous 24h'; }
        else { dotClass = 'stock-dot--out'; label = 'Rupture temporaire'; }
        stockEl.innerHTML = '<span class="stock-dot ' + dotClass + '" aria-hidden="true"></span> ' + label;
      }

      var addBtn = section.querySelector('.nutrikit-product__add-to-cart');
      if (addBtn) {
        var unavailable = variant.inventory_management === 'shopify' && (variant.inventory_quantity || 0) <= 0;
        if (unavailable) {
          addBtn.setAttribute('disabled', '');
          var lbl = addBtn.querySelector('.cart-label');
          if (lbl) lbl.textContent = 'Indisponible';
        } else {
          addBtn.removeAttribute('disabled');
          var lbl2 = addBtn.querySelector('.cart-label');
          if (lbl2) lbl2.textContent = 'Ajouter au panier';
        }
      }
    }

    variantRadios.addEventListener('change', function () {
      var v = findSelectedVariant();
      if (v) updateUI(v);
    });
  }

  /* ===== TABS ===== */
  function initTabs(section) {
    var tabBtns = section.querySelectorAll('.nutrikit-product__tabs .tabs-nav button');
    var tabPanels = section.querySelectorAll('.nutrikit-product__tabs .tab-panel');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        tabBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(function (p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = section.querySelector('#tab-' + target + '-' + section.dataset.sectionId);
        if (panel) {
          panel.classList.add('is-active');
          panel.hidden = false;
        }
      });
    });
  }

  /* ===== GALLERY THUMBS ===== */
  function initGalleryThumbs(section) {
    var thumbs = section.querySelectorAll('.nutrikit-product__gallery-thumb');
    var mainImg = section.querySelector('.nutrikit-product__gallery-main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.dataset.mediaSrc;
        if (src) {
          mainImg.src = src;
          var picture = mainImg.closest('picture');
          if (picture) {
            var sources = picture.querySelectorAll('source');
            sources.forEach(function (s) {
              s.setAttribute('srcset', src);
            });
          }
        }
      });
    });
  }

  /* ===== STICKY CTA MOBILE ===== */
  function initStickyCta(section) {
    var sectionId = section.dataset.sectionId;
    var cta = section.querySelector('.nutrikit-product__add-to-cart');
    var stickyCta = document.querySelector('#sticky-cta-' + sectionId);
    if (!cta || !stickyCta) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (window.innerWidth < 900) {
          stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
          stickyCta.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        } else {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        }
      });
    }, { rootMargin: '0px' });
    observer.observe(cta);

    // Hide sticky on resize to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900) {
        stickyCta.classList.remove('is-visible');
        stickyCta.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ===== INIT ===== */
  function initAll() {
    document.querySelectorAll('.nutrikit-product').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList && e.target.classList.contains('nutrikit-product')) {
      initSection(e.target);
    } else {
      var inside = e.target.querySelector ? e.target.querySelector('.nutrikit-product') : null;
      if (inside) initSection(inside);
    }
  });
})();

/* ============================================================
   NK CAROUSEL : sections cross-sell A et B
   Scroll horizontal a la fleche, masquage de la fleche si fin de track.
============================================================ */
(function () {
  function initCarousel(el) {
    var track = el.querySelector('[data-nk-carousel-track]');
    var nextBtn = el.querySelector('[data-nk-carousel-next]');
    if (!track || !nextBtn) return;

    function updateArrowVisibility() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      // Tolerance 4px pour eviter les approximations de calcul
      if (track.scrollLeft >= maxScroll - 4) {
        nextBtn.setAttribute('hidden', '');
      } else {
        nextBtn.removeAttribute('hidden');
      }
    }

    nextBtn.addEventListener('click', function () {
      var card = track.querySelector('.cross-sell-card, .complementary-card');
      var step = card ? card.offsetWidth + 16 : 280;
      track.scrollBy({ left: step * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrowVisibility, { passive: true });
    window.addEventListener('resize', updateArrowVisibility);
    updateArrowVisibility();
  }

  function initAllCarousels(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-nk-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllCarousels(); });
  } else {
    initAllCarousels();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    initAllCarousels(e.target);
  });
})();

/* Bouton "Donner mon avis" : remplace le onclick inline (CSP friendly + Safari < 13.1 compat) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-nk-write-review]');
  if (!btn) return;
  var sprBtn = document.querySelector('.jdgm-write-rev-link, .jdgm-write-review, .spr-summary-actions-newreview');
  if (sprBtn) sprBtn.click();
});
